import * as Ids from '@utils/ids';
import { CUSTOM_METRICS, reportCustomMetrics } from '@utils/owlReporter';

export const currentLoginWmPoiId = Ids.getWmPoiId();

export const getWmPoiId = (message: any) => {
    if (!message || typeof message !== 'object') return 'unknown';

    let wmPoiId = 'unknown';
    const wmPoiIdInMessage =
        message.wmPoiId || message.wm_poi_id || message.poiId || message.poi_id;
    if (wmPoiIdInMessage) {
        wmPoiId = `${wmPoiIdInMessage}`;
    }

    try {
        if (wmPoiId === '13055431' || Ids.getWmPoiId() === '13055431') {
            reportCustomMetrics(
                CUSTOM_METRICS.ORDER_DELAY.KEY,
                1,
                {
                    [CUSTOM_METRICS.ORDER_DELAY.TAGS.TYPE]: 'ifPoiEnableAutoAcceptLocally',
                },
                {
                    message,
                    wmPoiId,
                },
            );
        }
    } catch (e) {
        //
    }
    return wmPoiId;
};

export const canBeHandledByCurrentPoi = (message: any) => {
    const wmPoiId = getWmPoiId(message);

    return wmPoiId === 'unknown' || wmPoiId === currentLoginWmPoiId || currentLoginWmPoiId === '-1';
};

export const canBeHandledByCurrentSinglePoi = (message: any) => {
    return getWmPoiId(message) === currentLoginWmPoiId;
};
